var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-3 flex rounded-full",staticStyle:{"background-color":"#F7F7FF"}},[_c('div',{class:`h-3 rounded-full ${_vm.color}`,style:(`width: ${_vm.value}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }